import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  .workspaceSettings-inputWrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;
    position: relative;

    label {
      font-weight: 500;
      font-size: 12px;
      line-height: 100%;
      color: var(--color-text-muted);
      margin: 0 0 10px;
      display: block;
    }
  }

  input {
    height: 40px;
  }

  .workspaceSettings-errorMessage {
    color: #ff2f2f;
    font-weight: 500;
    font-size: 10px;
    line-height: 100%;
  }

  .workspaceSettings-infoMessage {
    color: var(--color-text-muted);
    text-align: center;
  }

  .largeText {
    text-align: center;
    margin-top: 0;
    font-size: 16px;
    font-weight: 300;
  }
`;
